module.exports = __webpack_public_path__ + "static/media/videonew.5db28ae.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videonew.mp4
// module id = veBo
// module chunks = 1